import { Link as ChakraLink } from '@chakra-ui/react'
import { Link as ReactRouterLink } from 'react-router-dom'

export const UserLink = ({
  userId,
  firstName,
  lastName,
  name,
  userName,
  sx,
}: {
  userId?: string
  firstName?: string
  lastName?: string
  userName?: string
  name?: string
  sx?: {}
}) => {
  return (
    <ChakraLink as={ReactRouterLink} to={`/user/${userId}`} sx={sx}>
      {firstName && lastName ? `${firstName} ${lastName}` : (name ?? userName)}
    </ChakraLink>
  )
}
